import * as React from 'react';
import {StyleProp, Text, TouchableOpacity, View, ViewStyle, Platform} from 'react-native';
import {Image} from '../image';
import {AcceptorResponsePayload} from '../../models/api';
import {useTheme} from '../../theme';
import {stripHTML} from '../../pipes';
import {GetStyles} from './style';
import {LK_PROD_ESKMO, LK_TEST_ESKMO} from '../../../screens/volunteersService/components/dobroWebView';

interface Props {
  acceptor: AcceptorResponsePayload;
  displayPhone?: boolean;
  displayWebsite?: boolean;
  style?: StyleProp<ViewStyle>;
  useHoverEffect?: boolean;
  onPress?: () => void;
}

const HEADER_BLOCK_SIZE = 120;

export const AcceptorCard: React.FC<Props> = ({
  acceptor: {id, name, logo, descriptionShort},
  style,
  useHoverEffect,
  onPress,
}) => {
  const theme = useTheme();

  const styles = GetStyles(theme, HEADER_BLOCK_SIZE);

  const absoluteImgLink = React.useMemo(
    () =>
      Platform.OS === 'web'
        ? logo
        : logo?.startsWith('http')
        ? logo
        : `${__DEV__ ? LK_TEST_ESKMO : LK_PROD_ESKMO}${logo}`,
    [logo],
  );

  return (
    <Container
      testID={`acceptor-item-${id}-id`}
      onPress={onPress}
      style={[styles.container, style]}
      useHoverEffect={useHoverEffect}>
      <React.Fragment>
        <View testID={`acceptor-item-${id}-body-id`} style={styles.body}>
          <Text testID={`acceptor-item-${id}-name-id`} style={styles.name} numberOfLines={2}>
            {name}
          </Text>
          <View testID={`acceptor-item-${id}-descriptionContainer-id`} style={styles.descriptionContainer}>
            <Text testID={`acceptor-item-${id}-description-id`} style={styles.description} numberOfLines={3}>
              {stripHTML(descriptionShort)}
            </Text>
          </View>
        </View>
        <View testID={`acceptor-item-${id}-logo-id`} style={styles.imageBlock}>
          <Image style={styles.logo} source={{uri: absoluteImgLink}} resizeMode='contain' />
        </View>
      </React.Fragment>
    </Container>
  );
};

interface ContainerProps {
  testID: string;
  children: React.ReactFragment;
  onPress?: () => void;
  style?: StyleProp<ViewStyle>;
  useHoverEffect?: boolean;
}

const Container = (props: ContainerProps) => {
  const {children, onPress, useHoverEffect, style, testID} = props;

  if (onPress) {
    return (
      <TouchableOpacity
        testID={testID}
        activeOpacity={Platform.OS === 'web' ? 1 : 0.5}
        onPress={onPress}
        style={style}
        {...{dataSet: {class: useHoverEffect ? 'acceptor-card' : 'acceptor-card--noHover'}}}>
        {children}
      </TouchableOpacity>
    );
  }

  return <View style={style}>{children}</View>;
};
